// https://hypergryph.feishu.cn/wiki/BlB3wOjOLiXX2Hko16KcVIQEnsc
var Collect = /** @class */ (function () {
    function Collect(props) {
        Object.defineProperty(this, "adapter", {
            enumerable: true,
            configurable: true,
            writable: true,
            value: void 0
        });
        this.adapter = props.adapter;
    }
    Object.defineProperty(Collect.prototype, "uid", {
        /**
         * collect_uid 参数
         */
        get: function () {
            var collect_uid = this.adapter.getStore().collect_uid;
            return collect_uid;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(Collect.prototype, "phone", {
        /**
         * collect_phone 参数
         */
        get: function () {
            var collect_phone = this.adapter.getStore().collect_phone;
            return collect_phone;
        },
        enumerable: false,
        configurable: true
    });
    return Collect;
}());
export { Collect };
